import { Route, Routes } from "react-router";

import { CoveragePage } from "./pages/CoveragePage";
import { CustomerCoveragePage } from "./pages/CustomerCoveragePage";

/**
 * The Coverage area, mounted at `/coverage/*` (CHT-768):
 *   /coverage                       the coverage gaps and who is available
 *   /coverage/customers/:customerId the cover of one customer
 */
export function CoverageRoutes() {
  return (
    <Routes>
      <Route index element={<CoveragePage />} />
      <Route path="customers/:customerId" element={<CustomerCoveragePage />} />
    </Routes>
  );
}
